import React, { useState, useEffect, useCallback } from "react";

import Select from "react-select";
import PageTitle from "../PageTitle/page_title";
import i18next from "i18next";
import { ChecklistReportService, TagsService } from "../../services";
import { DatePickerInput } from "../DatePickerInput";

const ChecklistDataDownloadForm = ({ onSubmit }) => {
  const DATA_DOWNLOAD_TYPE_OPTIONS = [
    {value: 'daily-completion-summary-data', label: 'Daily Completion Summary Data'}
  ];

  const [downloadType, setDownloadType] = useState(DATA_DOWNLOAD_TYPE_OPTIONS[0]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [tagOptions, setTagOptions] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);

  useEffect(() => {
    TagsService.listAll().then((response) => {
      setTagOptions(
        response.tags.filter((tag) => tag.tagType.token == 'checklist-type')
                     .map((tag) => ({ value: tag.id, label: tag.name, tag: tag }))
      );
    }).catch((error) => {
      console.error(error);
    });
  }, [onSubmit]);

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    onSubmit({ downloadType, startDate, endDate, checklistTag: selectedTag.tag });
  }, [onSubmit, downloadType, startDate, endDate, selectedTag]);

  return tagOptions ? (
    <div className="op-content-box filter-box" style={{marginBottom: 20}}>

      <form onSubmit={handleSubmit}>

        <ul className="list-inline clearfix">
          <li className="pull-left box-label"><h4 className="remove-margin-bottom">{i18next.t('filters')}</h4></li>
        </ul>

        <div className = "row">
          <div className="col-sm-4">
            <label>Type</label>
            <Select
              options={DATA_DOWNLOAD_TYPE_OPTIONS}
              clearable={false}
              value={downloadType}
              onChange={setDownloadType}
              searchable={false}
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-sm-2">
            <label>Tag</label>
            <Select
              options={tagOptions}
              clearable={false}
              value={selectedTag}
              onChange={setSelectedTag}
              searchable={true}
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-sm-2">
            <div className="pull-right">
              <label>{ i18next.t('start-date') }</label>
              <DatePickerInput
                input={{value: startDate}}
                meta={{}}
                onDayChange={setStartDate}
              />
            </div>
          </div>
          <div className="col-sm-2">
              <label>{ i18next.t('end-date') }</label>
              <DatePickerInput
                input={{value: endDate}}
                meta={{}}
                onDayChange={setEndDate}
              />
          </div>

          <div className="col-sm-2 pull-right">
            <label style={{visibility: 'hidden'}}>{ i18next.t('run-report') }</label>
            <ul className="list-inline clearfix">
              <li className="pull-left" style={{marginLeft: '15px'}}>
                <button type="submit" className="btn btn-sm btn-default pull-right" disabled={!(downloadType && startDate && endDate && selectedTag)}>{ i18next.t('form-labels.run-report') }</button>
              </li>
            </ul>
          </div>          

        </div>
      </form>
    </div>
  ) : (
    <div className="loader">{i18next.t("loading")}</div>
  );
};

const ChecklistDataDownload = () => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [query, setQuery] = useState(null);

    useEffect(() => {
      if (query) {
        const {downloadType, startDate, endDate, checklistTag} = query;

        ChecklistReportService.getChecklistDataDownload(downloadType.value, startDate.valueOf(), endDate.valueOf(), checklistTag.id, checklistTag.name).then(() => {
        }).catch((error) => {
            setErrorMessage("Unable to fetch download results.");
            console.error(error);
        });
      }
    }, [query]);
    
    return (
        <div>
            <div className="row">
                <PageTitle title='Checklist Data Download' />
            </div>
            { errorMessage && <div className="row" style={{paddingBottom: 30}}>{errorMessage}</div> }
            <div className="device-detail-report col-sm-12">
                <ChecklistDataDownloadForm onSubmit={setQuery} />
            </div>
        </div>
    );
};

export default ChecklistDataDownload;